import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf'
export default {
    loadUser: (context, payload = { data: '', request: 'dont' }) => {
        // console.log('loadUser. Request: ' + payload.request)
        axios.defaults.withCredentials = true
        return axios.get(constConf.user.url + '/user/profile').then(response => {
            if (response.data != null && response.data.length !== 0) {
                context.commit('loadUser', response.data)
            } else {

            }
            return response.data
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get user' + error)
        })
    },
    loadUserByModel: (context, model) => {
        context.commit('loadUser', model)
    },
    saveUser: (context, payload) => {
        let method = 'post'
        let url = constConf.user.url + ''
        if (payload.user_id != null) {
            method = 'put'
            url = constConf.user.url + '/user/update/' + payload.user_id
        }
        axios.defaults.withCredentials = true
        return axios({
            method: method,
            url: url,
            data: payload
        })
            .then((response) => {
                if (!response.data.hasOwnProperty('error')) {
                    let functionName = { put: 'setUser', post: 'addUser' }
                    context.commit(functionName[method], response.data)
                }
                return response // рабочий пример возврата данных
            })
            .catch((error) => {
                console.log('ошибка при записи модели user')
                console.log(error)
                return null
            })
    },
    changePassword: (context, payload) => {
        axios.defaults.withCredentials = true
        return axios.put(
            constConf.user.url + '/user/change-password',
            payload
        )
            .then((response) => {
                return response // рабочий пример возврата данных
            })
            .catch((error) => {
                console.log('ошибка при изменении пароля')
                console.log(error)
                return null
            })
    },
    deletePasswordsInForm: (context) => {
        context.commit('deletePasswordsInForm')
    },
    updateUserVkInfo: (context) => {
        context.commit('setLoaded', false)
        axios.defaults.withCredentials = true
        return axios.get(
            constConf.user.url + '/user/update-user-vk-info'
        )
            .then((response) => {
                context.commit('loadUser', response.data.success.data)
                // context.commit('setLoaded', true)
                return response
            })
            .catch((error) => {
                console.log('ошибка сохранения токена пользователя')
                console.log(error)
            })
    },
    loadVkGroups: (context, payload = { data: null, request: 'dont' }) => {
        axios.defaults.withCredentials = true
        return axios.get(
            constConf.user.url + '/user/get-vk-groups'
        )
            .then((response) => {
                if (response.data.hasOwnProperty('success')) {
                    context.commit('loadVkGroups', response.data.success.data)
                    return { success: { text: 'Группы успешно загружены!' } }
                } else {
                    return { error: { text: response.error.text } }
                }
            })
            .catch((error) => {
                console.log('Ошибка при загрузке групп вк')
                console.log(error)
            })
    },
    logout: (context) => {
        axios.defaults.withCredentials = true
        axios.post(constConf.user.url + '/user/logout')
            .then(response => {
                console.log(response)
                var d = new Date()
                d.setDate(d.getDate() - 1)
                // document.cookie = 'user=login' + '; expires=' + d.toUTCString()
                var cookieDate = new Date() // Текущая дата и время
                cookieDate.setTime(cookieDate.getTime() - 1)
                document.cookie = 'user=login' + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;'
                this.$router.push({ path: '/login' })
            })
            .catch(function (error) {
                console.error(error.response)
            })
    }
}
